module.exports = __webpack_public_path__ + "a9e6611007ed87f86bba34cf9a7648c2.svg";